import { forwardRef } from 'react';
import { ITEM_HEIGHT } from './TimelineItemConstants';

export const TimelineItemResizeHandle = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    handleAxis?: string;
    itemTopOffset?: number;
    itemHeight?: number;
    isCompact?: boolean;
    barColor?: string;
  }
>(
  (
    {
      handleAxis,
      itemTopOffset = 0,
      itemHeight = ITEM_HEIGHT,
      isCompact = false,
      barColor: _barColor,
      ...props
    },
    ref,
  ) => {
    const handleHeight = isCompact ? itemHeight - 8 : Math.min(24, itemHeight);
    const handleTopOffset = itemTopOffset + (itemHeight - handleHeight) / 2;

    return (
      <div
        ref={ref}
        data-no-dnd="true"
        data-no-rubber-band="true"
        className={`react-resizable-handle react-resizable-handle-${handleAxis} absolute bg-bg-neutral cursor-ew-resize z-10 opacity-0 group-hover:opacity-100 in-data-rubber-band-active:opacity-0! w-0.5 rounded-lg`}
        style={{
          touchAction: 'none',
          top: handleTopOffset,
          height: handleHeight,
          ...(handleAxis === 'w' ? { left: 6 } : handleAxis === 'e' ? { right: 6 } : {}),
        }}
        {...props}
      />
    );
  },
);

TimelineItemResizeHandle.displayName = 'TimelineItemResizeHandle';
